import { FormControl, FormControlLabel, FormHelperText, FormLabel, Radio, RadioGroup, TextField } from "@mui/material";
import { FormikProps, getIn } from "formik";
import React from "react";
import { GeneralInformationAnswer, GeneralInformationModel } from "../../../models/workflow.model";
import styles from "./LegalQuestions.module.scss";

interface Props {
  answer: GeneralInformationAnswer;
  propertyName: string;
  index: number;
  isReadOnly: boolean;
  formik?: FormikProps<GeneralInformationModel> | undefined;
}

const _textQuestion: React.FC<Props> = ({ answer, propertyName, index, isReadOnly, formik }) => {
  const valuePropName = `${propertyName}[${index}].value`;
  const error = formik ? getIn(formik.errors, valuePropName) : false;
  const touched = formik ? getIn(formik.touched, valuePropName) : false;

  const handleBlur = (event: any) => {
    if (formik) {
      formik.handleBlur(event);
    }
  };

  const handleChange = (event: any) => {
    if (formik) {
      formik.handleChange(event);
    }
  };

  return (
    <div className={styles.questionBox}>
      <FormControl fullWidth>
        <FormLabel id={`${answer.legalQuestion.id}-label`}>{answer.legalQuestion.question}</FormLabel>
        <TextField
          aria-labelledby={`${answer.legalQuestion.id}-label`}
          id={valuePropName}
          name={valuePropName}
          fullWidth
          inputProps={{ readOnly: isReadOnly }}
          value={answer.value || ""}
          onBlur={handleBlur}
          onChange={handleChange}
          helperText={touched && error ? error : ""}
          error={Boolean(touched && error)}
        />
      </FormControl>
    </div>
  );
};

const _optionsQuestion: React.FC<Props> = ({ answer, propertyName, index, isReadOnly, formik }) => {
  const valuePropName = `${propertyName}[${index}].value`;
  const error = formik ? getIn(formik.errors, valuePropName) : false;
  const touched = formik ? getIn(formik.touched, valuePropName) : false;

  const handleBlur = (event: any) => {
    if (formik) {
      formik.handleBlur(event);
    }
  };

  const handleChange = (event: any) => {
    if (formik) {
      formik.handleChange(event);
    }
  };
  return (
    <div className={styles.questionBox}>
      <FormControl fullWidth error={Boolean(error)}>
        <FormLabel className={styles.textQuestion} id={`${answer.legalQuestion.id}-label`}>
          {answer.legalQuestion.question}
        </FormLabel>
        <RadioGroup
          aria-labelledby={`${answer.legalQuestion.id}-label`}
          id={valuePropName}
          name={valuePropName}
          row
          value={answer.value || ""}
          onChange={handleChange}
          onBlur={handleBlur}
          className={styles.options}
        >
          {answer.legalQuestion.options.map((x) => (
            <FormControlLabel
              key={`legal_question_${answer.legalQuestion.id}_${x.id}`}
              value={x.option}
              control={<Radio inputProps={{ disabled: isReadOnly }} />}
              label={x.option}
            />
          ))}
        </RadioGroup>
        <FormHelperText>{touched && error}</FormHelperText>
      </FormControl>
    </div>
  );
};

export const TextQuestion = React.memo(
  _textQuestion,
  (prevProps, nextProps) =>
    prevProps.answer.value === nextProps.answer.value &&
    getIn(prevProps.formik?.errors, prevProps.propertyName) ===
      getIn(nextProps.formik?.errors, nextProps.propertyName) &&
    getIn(prevProps.formik?.touched, prevProps.propertyName) ===
      getIn(nextProps.formik?.touched, nextProps.propertyName)
);

export const OptionsQuestion = React.memo(
  _optionsQuestion,
  (prevProps, nextProps) =>
    prevProps.answer.value === nextProps.answer.value &&
    getIn(prevProps.formik?.errors, prevProps.propertyName) ===
      getIn(nextProps.formik?.errors, nextProps.propertyName) &&
    getIn(prevProps.formik?.touched, prevProps.propertyName) ===
      getIn(nextProps.formik?.touched, nextProps.propertyName)
);
